<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top = "0" id="searchForm_iotDevice">
      <el-col :span="5">
        <el-form-item label="项目名称">
          <el-select
            v-model="query.projectId"
            placeholder="请选择项目名称"
            style="width: 100%"
            @change="projectSearchChange"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="所属区域">
          <el-select
            v-model="query.areaId"
            placeholder="请选择存放区域"
            style="width: 100%"
            ref="connectSelect"
            name="connectSelect"
          >
            <el-option
              :value="query.areaId"
              show-all-levels
              :label="query.areaName"
            >
              <el-tree
                node-key="id"
                :data="treeFormAreaData"
                :props="treeProps"
                ref="areaTree"
                :load="searchAreaLazyLoadTree"
                lazy
                @node-click="searchAreaNodeTreeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="仪表名称">
          <el-input v-model="query.meterName" maxlength="30"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="仪表编号">
          <el-input v-model="query.meterNo" maxlength="30"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="开始日期">
          <el-date-picker
            teyp="date"
            :clearable="false"
            v-model="query.startTime"
            value-format="yyyy-MM-dd 00:00:00"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="结束日期">
          <el-date-picker
            teyp="date"
            :clearable="false"
            v-model="query.endTime"
            value-format="yyyy-MM-dd 23:59:59"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-button icon="el-icon-search" size="small" type="primary" @click="search">
          搜索
        </el-button>
        <el-button icon="el-icon-delete" size="small" @click="searchReset">
          重置
        </el-button>
      </el-col>
    </el-form>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="notifyWays" slot-scope="scope" >
        <el-tag>{{getNotifyName(scope.row.notifyWays)}}</el-tag>
      </template>
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.energywarnings_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/views/v4ward/energy/warnings/api/energywarnings";
  import {lazyTree } from "@/api/crmedical/project/area";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {mapGetters} from "vuex";
  import {getDictionary}  from "@/api/system/dict";

  export default {
    data() {
      return {
        form: {},
        query: {
          projectId: '',
          areaId: '',
          areaName:'',
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: false,
          dialogClickModal: false,
          columnBtn: false,
          align: 'center',
          indexLabel: '序号',
          menu: false,
          column: [
            {
              label: "区域",
              prop: "areaName",
            },
            {
              label: "项目ID",
              prop: "projectId",
              hide:true,
            },
            {
              label: "仪表名称",
              prop: "meterName",
            },
            {
              label: "仪表编号",
              prop: "meterNo",
            },
            {
              label: "设定范围",
              prop: "waringRange",
            },
            {
              label: "实际数值",
              prop: "readNumber",
              width: 100,
            },
            {
              label: "参数名称",
              prop: "paramCodeName",
            },
            {
              label: "发生时间",
              prop: "warningTime",
              width: 130,
            },
            {
              label: "通知方式",
              prop: "notifyWays",
              slot: true,
              width: 170,
            },
          ]
        },
        data: [],
        treeFormAreaData: [],
        projectList: [],
        treeProps: {
          //标题
          label: "name",
          //值
          value: "id",
          //子节点
          children: "zones",
          //是否叶子节点
          isLeaf: "hasChildren",
          //本节点类型key值
          objectType: "id",
          //本节点类型名
          objectTypeName: "name",
        },
        systemNotifyWaysList: [],
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.energywarnings_add, false),
          viewBtn: this.vaildData(this.permission.energywarnings_view, false),
          delBtn: this.vaildData(this.permission.energywarnings_delete, false),
          editBtn: this.vaildData(this.permission.energywarnings_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created(){
      getDictionary({ code: "system_notify_way" }).then((res) => {
        this.systemNotifyWaysList = res.data.data;
      });
      getProjectList().then((data) => {
        this.projectList = data.data;
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          this.initAreaList();
          this.onLoad();
        }
      });
    },
    methods: {
      getNotifyName(notifyWays){
        var notifyNames = [];
        this.systemNotifyWaysList.forEach((item) =>{
          if(notifyWays.includes(item.dictKey)){
            notifyNames.push(item.dictValue);
          }
        });
        return notifyNames.join(',');
      },
      searchAreaNodeTreeClick(node){
        this.query.areaId = node.id;
        this.query.areaName = node.name;
      },
      searchAreaLazyLoadTree(node,resolve) {
        let id ;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        lazyTree({ parentId: id, projectId: this.query.projectId }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        });
      },
      projectSearchChange(value){
        console.log(value);
        this.initAreaList();
      },
      initAreaList(){
        lazyTree({ parentId: 0, projectId: this.query.projectId }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          this.treeFormAreaData = data;
          this.query.areaName='';
          this.query.areaId='';
        });
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        } else if ("add" === type) {
          this.cleanForm();
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        this.query = {
          projectId: '',
          areaId: '',
          areaName:'',
          meterType:'',
        };
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          this.initAreaList();
        }
        this.page.currentPage = 1;
        this.onLoad();
      },
      search(){
        this.page.currentPage = 1;
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        if(this.vdui.isEmpty(this.query.projectId)){
          return;
        }
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
